import {
  TYPE2CLASS
} from '../core/icon-class';
// import {
//   AlertModalController
// } from './editor/alert-modal.component';

require('./filter-dimension-node.component.scss');

class FilterDimensionNodeController {
  constructor(
    $element,
    $timeout,
    $scope,
    CurrentFilterService,
    PermissionService,
    $rootScope,
    RouterService,
    FilterResource,
    $modal,
    AggregateDataService,
    CurrentModelService,
    StatusCheckerService,
    ErrorHandlerService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.permission = PermissionService;
    this.currentFilter = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.filterBar = CurrentFilterService.filterBar;
    this.TYPE2CLASS = TYPE2CLASS;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.$modal = $modal;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.StatusCheckerService = StatusCheckerService;
    this.AggregateDataService.filterData$.subscribe(() => {
      this.initDimensions();
    });

  }

  initDimensions() {
    // this.$timeout(() => {
      const dim = this.filterBar.drilldown[0];
      this.hasRules = this.isHasRules;
      this.isAssignSchedule = dim.indexOf('agent_agent@computer_name:computer_name') === 0 ||
        dim.indexOf('agent_account@user_name:user_name') ||
        dim.indexOf('agent_account@full_name:full_name') ||
        dim.indexOf('agent_account@office:office');

      this.isAccountUserName = dim.indexOf('agent_account@user_name:user_name') === 0;
      this.isAccountFullName = dim.indexOf('agent_account@full_name:full_name') === 0;
      this.isAddToFilter = dim.indexOf('agent_application@app_name:app_name') != -1 ||
        dim.indexOf('agent_web@site:site') != -1;

      this.isAgentComputerName = dim.indexOf('agent_agent@computer_name:computer_name') === 0;

      this.showProperties = dim.indexOf('agent_account@user_name:user_name') != -1 ||
        dim.indexOf('agent_agent@computer_name:computer_name') != -1 ||
        dim.indexOf('agent_account@office:office') != -1 ||
        this.hasRules;

      this.isHasCard = this.hasCard();

    // }, 0);
  }

  getAssignScheduleRef(cell) {
    return `admin/work_calendar/weekscheduledimension/add/?dimension=${
      this.filterBar.drilldown[0]}&value=${this.getCellLabel(cell)}`;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get isNameOrdered() {
    return this.router.aggregateOrder === 'nameAsc' || this.router.aggregateOrder === 'nameDesc';
  }

  get aggregate() {
    return this.AggregateDataService.aggregate;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get isLoading() {
    return this.AggregateDataService.loading;
  }

  get isLoadingMore() {
    return this.AggregateDataService.loadingMore;
  }

  get cells() {
    return this.aggregate && this.aggregate.cells || [];
  }

  get total() {
    return this.hasData() ? {
      cells: this.aggregate.cells.length,
      events: this.AggregateDataService.events.total,
      max: this.AggregateDataService.events.max
    } : {
      cells: 0,
      events: 0,
      max: 0
    };
  }

  shadowWidth(cell) {
    if (!cell.record_count || !this.total.max) return '0';
    return `${cell.record_count / this.total.max * 100}%`;
  }

  hasData() {
    return (this.aggregate &&
      this.aggregate.cells &&
      this.aggregate.cells.length > 0);
  }

  // get isAddToFilter() {
  //   const dim = this.filterBar.drilldown[0];
  //   return dim.indexOf('agent_application@app_name:app_name') != -1 ||
  //     dim.indexOf('agent_web@site:site') != -1;
  // }

  addToFilter(cell) {
    this.router.changeCut(this.filterBar.drilldown[0], this.getCellLabel(cell), 'cut-edit');
  }

  get isHasRules() {
    const dimArr = this.filterBar.drilldown[0].split('@');
    const dimName = dimArr[0];
    const dim = this.model.dimensions.find(dm => dm.name === dimName);
    if (!dim) return false;
    const dimHierarchy = dimArr[1].split(':')[0];
    const hierarchy = dim.hierarchies.find(h => h.name === dimHierarchy);
    if (!hierarchy) return false;
    return hierarchy.rule_groups.length > 0;
  }

  // get showProperties() {
  //   return this.filterBar.drilldown[0].indexOf('agent_account@user_name:user_name') != -1 ||
  //     this.filterBar.drilldown[0].indexOf('agent_agent@computer_name:computer_name') != -1 ||
  //     this.filterBar.drilldown[0].indexOf('agent_account@office:office') != -1 ||
  //     this.hasRules;
  // }

  hasCellFilter(cell) {
    const filter = this.model.getCellFilter(this.filterBar.drilldown[0], cell);
    return this.filter.hasFilter(filter);
  }

  getCellFilter(cell) {
    return this.model.getCellFilter(this.filterBar.drilldown[0], cell);
  }

  getCellLabel(cell) {
    return cell.cellLabel;
  }

  setCellFilter(cell) {
    const filter = this.getCellFilter(cell);
    this.filter.toggleFilter(filter);
    this.$scope.$root.$broadcast('dimensionToggle');
    this.router.filterChanged();
  }

  hasCard() {
    return [
      'agent_agent',
      'agent_account',
      'agent_application',
      'agent_web',
      'agent_networkconnection',
      'agent_attachedfile',
      'agent_device',
      'agent_dialog',
      'agent_appinstallation',
      'analytics_filter',
    ].some((dim) => this.filterBar.drilldown[0].startsWith(dim));
  }

  openCard(cell) {
    const filter = this.getCellFilter(cell);
    this.router.openCard(filter);
  }

  openRules(cell) {
    const cutObj = this.getCellFilter(cell);
    this.router.changeCut(cutObj.dimension, cutObj.label, 'rules-edit');
  }

  connectRemote(cell, i) {
    if (this.menuItem == cell) {
      this.menuItem = null;
      return;
    }
    if (cell.remote && cell.remote.length === 1) this.connectRemoteUser(cell.remote[0]);
    else if (i >= 0) this.connectRemoteUser(cell.remote[i]);
  }

  connectRemoteUser(user) {
    this.menuItem = null;
    if (user.sid)
      this.router.openFrame('/remote/?hwid=' + user.hwid + '/' + user.sid);
    else
      this.router.openFrame('/remote/?hwid=' + user.hwid);
  }

}

export const FilterDimensionNodeComponent = {
  template: require('./filter-dimension-node.component.html'),
  controller: FilterDimensionNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-dimension-node.component.js